import type { DifficultyLevel } from '@fafi/shared';

// D46 — difficulty display copy (FINAL, verbatim). Difficulty is an ONLINE-ROOM setting only; the host
// picks it in the create-room lobby (main.ts renders the number boxes with the lobby's own button style
// and calls game.requestDifficulty). This module owns just the level names + descriptions shown there.

const LEVELS: Record<DifficultyLevel, { name: string; desc: string }> = {
  1: { name: 'training wheels', desc: 'Your opponents are dead and the goal is empty. Almost.' },
  2: { name: 'playing with grandma', desc: 'But without the cookies after.' },
  3: { name: 'a coffee and a cigarette', desc: "basically PED's" },
  4: { name: 'asking the hot girl to prom', desc: "You wouldn't." },
  5: { name: 'chew glass', desc: 'If you hate fun.' },
};

/** The human-facing name for a level (the create-room lobby line). */
export function difficultyName(level: DifficultyLevel): string {
  return LEVELS[level].name;
}
/** The human-facing description for a level (rendered under the picker row). */
export function difficultyDesc(level: DifficultyLevel): string {
  return LEVELS[level].desc;
}
